
export interface GetAllCardsResponse {
    customerId: string;
    merchantId: string;
    cards: Array<{
        cardToken: string;
        cardReference: string;
        cardFingerprint: string;
        cardNumber: string;
        cardIsin: string;
        cardExpYear: string;
        cardExpMonth: string;
        nameOnCard: string;
        nickname: string;
        cardBrand: string;
        cardType: string;
        cardIssuer: string;
        cardBalance?: null;
        isFoodCard: boolean;
        iconUrl: string;
        fullImageUrl: string;
        tokenizeSupport: boolean;
        isSecured: boolean;
        token?: null;
    }>;
    merchantInfo: {
        merchantId: string;
        merchantName: string;
        returnToUrl: string;
    };
    showAddNewCard: boolean;
    showEditOption: boolean;
    meta: {
        tokenizationMeta: {
            title: string;
            message: string;
            points: Array<{
                iconUrl: string;
                message: string;
            }>;
        };
    };
}

export interface GetCardDetailsResponse {
    cardBrand: string;
    imageId: string;
    fullImageUrl: string;
    enabled: boolean;
    disableReason: string;
    tokenizeSupport: boolean;
    bin: string;
    nonFoodDisabled?: boolean;
    nonFoodDisabledReason?: string;
    country?: string;
    skipClientCardValidation: boolean;
    isCardEligibleForSelectedEmi?: boolean;
}

export enum CREDIT_TYPE {
    SELFLOAD = "selfload",
    VOUCHER = "voucher",
}
